import { UserData } from 'components/Sidebar/Sidebar_Principal';
import Cargando from 'components/Varios/Cargando';
import React, { useEffect, useState } from 'react'

//BOOTSTRAP
import { Row, Col, Container, Card, CardHeader, CardBody } from "reactstrap";
import { Tab, Tabs } from 'react-bootstrap';



import { authenticationService } from 'services/authentication.service';
import CardInfoConvenios from './CardInfoConvenios';
import { ObtenerConveniosUsuario } from './functionsConvenios';
import { InformacionConvenios, StatesConvenios } from './TypesConvenios';

//ESTILOS
import "./Convenios.scss"


const Convenios = () => {

    const [stateConvenios, setstateConvenios] = useState<StatesConvenios>({
        listaconvenios: [],
        loadingConvenios: false
    });

    async function GetInformacion(infoUsuario: UserData) {
        setstateConvenios({ ...stateConvenios, loadingConvenios: true });
        const resultado: InformacionConvenios[] = await ObtenerConveniosUsuario(infoUsuario);
        setstateConvenios({ ...stateConvenios, loadingConvenios: false, listaconvenios: resultado });

    }

    const GetConveniosByEstado = (listadoConvenios: Array<InformacionConvenios>, estadoDeseado: string) => {
        var filtrado = listadoConvenios.filter((convenio, indiceConvenio) => { return convenio.estado === estadoDeseado });
        var cantidadFiltrado = filtrado.length
        var CardsConvenios = filtrado.map((valores, indiceValores) => {
            return (
                <Col sm={12} md={6} xl={4} key={"CardConvenio" + estadoDeseado + indiceValores + 1} className="mb-5">
                    <CardInfoConvenios datosCards={valores} indice={indiceValores + 1} total={cantidadFiltrado} />
                </Col>
            )
        })
        return CardsConvenios;
    }

    const NoConveniosComponent = () => {
        return (
            <div>No administra convenios institucionales</div>
        )
    }

    useEffect(() => {
        var userInfo: UserData = authenticationService.currentUserValue;
        GetInformacion(userInfo);
    }, [])



    if (stateConvenios.loadingConvenios) {
        return <Cargando mensaje='Cargando Convenios' />
    }


    return (
        <div className="content">

            <Row className="row-no-margin">
                <Col xl={12} >
                    <Card className="principal">
                        <CardHeader>
                            <h5 className="title">CONVENIOS ADMINISTRADOS</h5>
                            <CardBody className="main-content">
                                <div id="container_cardbody_convenios">
                                    <Tabs
                                        id="tabConvenios"
                                        defaultActiveKey="Vigentes"
                                    >
                                        <Tab
                                            eventKey="Vigentes" title="Vigentes"
                                        >
                                            <Row >
                                                {stateConvenios.listaconvenios.length !== 0 &&
                                                    GetConveniosByEstado(stateConvenios.listaconvenios, "Vigente")
                                                }
                                                {
                                                    stateConvenios.listaconvenios.length === 0 &&
                                                    NoConveniosComponent()
                                                }
                                            </Row>
                                        </Tab>
                                        <Tab
                                            eventKey="Finalizados" title="Finalizados"
                                        >
                                            <Row >
                                                {stateConvenios.listaconvenios.length != 0 &&
                                                    GetConveniosByEstado(stateConvenios.listaconvenios, "Finalizado")
                                                }
                                                {
                                                    stateConvenios.listaconvenios.length === 0 &&
                                                    NoConveniosComponent()
                                                }
                                            </Row>
                                        </Tab>
                                    </Tabs>

                                </div>
                            </CardBody>
                        </CardHeader>
                    </Card>
                </Col>
            </Row>

        </div>

    )
}

export default Convenios